import React, { useState } from 'react';
import './Sidebar.css';
import { ReactComponent as Overviewicon } from '../assets/planetsystem/overviewicon.svg'
import { ReactComponent as Plantsicon } from '../assets/planetsystem/trees.svg'
import { ReactComponent as Donateicon } from '../assets/planetsystem/donateicon.svg'
import { ReactComponent as Pricingicon } from '../assets/planetsystem/pricingicon.svg'
import { ReactComponent as Settingicon } from '../assets/planetsystem/settingicon.svg'
import { ReactComponent as Recurringicon } from '../assets/planetsystem/Recurring.svg'
import { Link, NavLink, useNavigate } from 'react-router-dom';
import ENV from '../constants/env-constants';

function Sidebar() {
    const navigate = useNavigate();

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => {
      setSidebarOpen(!sidebarOpen);
    };

    // Define the logout function
    const logout = async () => {
      try {
        localStorage.removeItem('userid');
        // localStorage.removeItem('loginEmail');
        localStorage.removeItem('token');
        // Make a request to the backend logout endpoint
        const response = await fetch(`${ENV.API_URL}/api/auth/signout`, {
          method: 'POST', // or 'GET', depending on your backend
          // credentials: 'include', 
        });
        
        if (response.ok) {
          // If logout is successful, redirect to the home page
          navigate('/');
        } else {
          console.error('Logout failed');
        }
      } catch (error) {
        console.error('Error during logout:', error);
      }
    };

    const sidebarStyle = {
      display: sidebarOpen ? 'block' : 'none',
      // ... you can add other styles here if needed ...
    };
  return (
    <>
    {/* <button onClick={toggleSidebar} className="sidebar-toggle">Toggle Sidebar</button> */}

    <aside id="layout-menu" style={sidebarStyle} className={`layout-menu menu-vertical menu bg-menu-theme ${sidebarOpen ? 'sidebar-open' : ''}`}>
      
    <div className="app-brand demo">
      {/* <a to= className="app-brand-link"> */}
      <Link to='/dashboard/home' className="app-brand-link">
        <span className="app-brand-logo demo custombrandlogocont">
          <img className="sidebarlogo" src='/img/img/Blue_Planet_v122823.jpg'></img>
        </span>
        
        {/* <span className="app-brand-text demo menu-text fw-bold ms-2">Blue Planet</span> */}
      {/* </a> */}
      </Link>
      {/* <a href="#" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none" onClick={toggleSidebar}>
          <i className="bx bx-menu bx-sm align-middle"></i>
          sdfsdfsdfdf
      </a> */}
    </div>
    <div className="menu-inner-shadow" />
    <ul className="menu-inner py-1 menu-innercustom">
      {/* Layouts */}
      
      <li className="menu-item">
        {/* <a href="javascript:void(0);" className="menu-link menu-toggle menu-linkcustom"> */}
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/home">
          {/* <i className="menu-icon tf-icons bx bx-layout" /> */}
          {/* <img src={Overviewicon} style={{fill:'red!important'}} className="menu-icon tf-icons" alt="SV" /> */}
          <Overviewicon className='menu-icon tf-icons sidebar-icon' />
          <div data-i18n="Layouts">Overview</div>
        </NavLink>
      </li>

      <li className="menu-item">
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/myplants">
            <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' />
            <div data-i18n="Layouts">My Plants</div>
        </NavLink>
      </li>

      <li className="menu-item">
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/mysubscriptions">
            <Recurringicon className='menu-icon tf-icons  sidebar-iconstroke' />
            <div data-i18n="Layouts">My Subscriptions</div>
        </NavLink>
      </li>

      <li className="menu-item">
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/donate">
          <Donateicon  className='menu-icon tf-icons  sidebar-icon'/>
          <div data-i18n="Layouts">Donate</div>
        </NavLink>
      </li>

      <li className="menu-item">
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/pricing">
          <Pricingicon  className='menu-icon tf-icons sidebar-icon'/>
          <div data-i18n="Layouts">Pricing</div>
        </NavLink>
      </li>

      <li className="menu-item">
        <NavLink className="menu-link menu-toggle menu-linkcustom" to="/dashboard/settings">
          <Settingicon className='menu-icon tf-icons sidebar-icon'/>
          <div data-i18n="Layouts">Settings</div>
        </NavLink>
        
      </li>
        <li className="menu-item">
            <Link className="menu-link menu-toggle menu-linkcustom" onClick={logout}>
                {/* <Plantsicon className='menu-icon tf-icons  sidebar-iconstroke' /> */}
                <div data-i18n="Layouts">Log out</div>
            </Link>
        </li>
    </ul>
    
    </aside>
    <div className={`sidebar-toggle ${sidebarOpen ? 'transform' : ''}`} onClick={toggleSidebar}>
          <a className="">
            <i className="bx bx-menu bx-md"  style={{backgroundColor: 'white'}}/>
          </a>
    </div>
    </>
  );
}

export default Sidebar;